import { defineComponent } from "vue";
import ModalView from "@/components/modal-view";

export default defineComponent({
  template: `
      <ModalView
          v-if="isOnExitModalVisible"
          @hide="this.hideOnExitModal"
          class="exit-intent"
          :contentPadding="false"
      >
      <template #header>
        <slot name="header"></slot>
      </template>
      <slot></slot>
      <template #footer>
        <slot name="footer"></slot>
      </template>
      </ModalView>
    `,
  name: "OnExitModalView",
  components: {
    ModalView,
  },
  data() {
    return {
      lastShownAt: null,
      isOnExitModalVisible: false,
      isOnExitModalSnoozed: false,
    };
  },
  props: ["name"],
  methods: {
    async showOnExitModal(e: MouseEvent) {
      if (await this.shouldShowOnExitModal(e)) {
        sessionStorage.setItem("OnExitModalView.LastShow." + this.name, new Date().getTime().toString());

        this.isOnExitModalVisible = true;
      }
    },
    async shouldShowOnExitModal(e: any) {
      if (e.toElement || e.relatedTarget || this.isOnExitModalSnoozed || e.clientY > 0) {
        return false;
      }
      //! Order already submitted => no show
      const [newClientLastSubmit, existingClientLastSubmit] = [
        sessionStorage?.getItem("OrderFormNewClient.stepOne.lastSubmittedAt"),
        sessionStorage?.getItem("OrderFormExistingClient.stepThree.lastSubmittedAt"),
      ];
      if (newClientLastSubmit !== null || existingClientLastSubmit !== null) {
        return false;
      }
      //! Banner already shown this session => no show
      const lastShownAtRaw = sessionStorage.getItem("OnExitModalView.LastShow." + this.name);
      if (lastShownAtRaw) {
        const lastShownAt = parseInt(lastShownAtRaw);
        if (!isNaN(lastShownAt)) {
          this.lastShownAt = lastShownAt;
        }
      }
      //TODO: ?? Add logic here if the banner should be shown after certain time
      return this.lastShownAt === null;
    },
    async hideOnExitModal() {
      this.isOnExitModalVisible = false;
      this.isOnExitModalSnoozed = true;
    },
  },
  mounted() {
    document.addEventListener("mouseout", this.showOnExitModal);
  },
  unmounted() {
    document.removeEventListener("mouseout", this.showOnExitModal);
  },
});
